import { OverlayPosition } from "./model";

export interface CreateOverlayProps {
	dropShadow: boolean;
	allowScroll?: boolean;
	position: OverlayPosition;
	onShadowClick?: () => void;
}

export interface OverlayRef {
	destroy(): void;
}

export const OverlayService = {
	createOverlay: (element: HTMLDivElement, props: CreateOverlayProps) => {
		const overlayRootElement = document.querySelector('#overlay-root');
		if (!overlayRootElement)
			throw 'Overlay root not found';

			element.classList.add('overlay-container');
		if (props.dropShadow)
			element.classList.add('overlay-container-drop-shadow');
		if (props.allowScroll)
			element.classList.add('overlay-container-scroll');
		element.classList.add(`overlay-container-position-${props.position.toLowerCase()}`);

		if (props.onShadowClick != null) {
			const effectiveOnShadowClick = props.onShadowClick;
			element.onclick = event => {
				if (event.target === element) {
					effectiveOnShadowClick();
				}
			}
		}

		overlayRootElement.appendChild(element);

		const overlayRef: OverlayRef = {
			destroy: () => { overlayRootElement.removeChild(element); }
		}

		return overlayRef;
	}

	// showInOverlay: (componentFactory: (owner: OverlayRef) => JSX.Element, props: OverlayProps) => {
	// 	const overlayRootElement = document.querySelector('#overlay-root');
	// 	if (!overlayRootElement)
	// 		throw 'Overlay root not found';

	// 	const overlayElement = document.createElement('div');
	// 	overlayElement.classList.add('overlay-container');
	// 	if (props.dropShadow)
	// 		overlayElement.classList.add('overlay-container-drop-shadow');
	// 	if (props.allowScroll)
	// 		overlayElement.classList.add('overlay-container-scroll');
	// 	overlayElement.classList.add(`overlay-container-position-${props.position.toLowerCase()}`);

	// 	if (props.onShadowClick != null) {
	// 		const effectiveOnShadowClick = props.onShadowClick;
	// 		overlayElement.onclick = event => {
	// 			if (event.target === overlayElement) {
	// 				effectiveOnShadowClick();
	// 			}
	// 		}
	// 	}

	// 	overlayRootElement.appendChild(overlayElement);

	// 	const overlayRef: OverlayRef = {
	// 		destroy: () => { overlayRootElement.removeChild(overlayElement); }
	// 	}

	// 	const component = componentFactory(overlayRef);

	// 	render(component, overlayElement);

	// 	return overlayRef;
	// }
}
